var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"z-tabs",class:`z-tabs--theme-${_vm.theme}`},[_c('div',{staticClass:"z-tabs__container"},[_c('div',{staticClass:"z-tabs__header"},[_vm._t("label")],2)]),_vm._v(" "),_vm._t("content")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }